import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useParams } from "react-router-dom";
import DnerhsApi from "api/DnerhsApi";
import Alert from "components/Alert";
import history from "utils/History";
import { trackPromise } from "react-promise-tracker";

const useStyles = makeStyles((theme) => ({
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "400px",
  },
}));

/**
 * Componente DetalleCronograma
 * 
 * Este componente redirige a la vista completa del cronograma (CronogramaPractica/Form.js)
 * ya que esa vista ya contiene toda la información detallada del cronograma.
 * 
 * Flujo:
 * 1. Recibe cronogramaId desde la URL
 * 2. Obtiene los datos de la práctica para conseguir el convenioId
 * 3. Redirige a /convenios/cronogramasPracticas/editar/:convenioId/:cronogramaId
 */
const DetalleCronograma = () => {
  const classes = useStyles();
  const { cronogramaId } = useParams();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    redirectToCronogramaView();
  }, [cronogramaId]);

  const redirectToCronogramaView = async () => {
    try {
      setLoading(true);
      
      // Obtener datos de la práctica para conseguir el convenioId
      const practicaResponse = await trackPromise(
        DnerhsApi.get(`/convenios/practicas/${cronogramaId}`)
      );
      
      const practica = practicaResponse.data;
      const convenioId = practica.convenio?.id;

      if (!convenioId) {
        Alert.show({
          message: "No se pudo obtener el convenio asociado a esta práctica",
          type: "error",
        });
        history.goBack();
        return;
      }

      // Redirigir a la vista completa del cronograma
      history.replace({
        pathname: `/convenios/cronogramasPracticas/editar/${convenioId}/${cronogramaId}`,
        state: { edit: true, fromPracticasConvenio: true }
      });

    } catch (error) {
      console.error("Error al cargar datos:", error);
      Alert.showServerError(error);
      history.goBack();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className={classes.loading}>
      <CircularProgress />
    </Box>
  );
};

export default DetalleCronograma;

